import { styled } from '@mui/material/styles';

/**
 * <img> mit sx-Unterstützung. Anders als <Box component="img"> landen width/height hier als
 * HTML-Attribute (Seitenverhältnis → kein Layout-Springen), nicht als CSS.
 */
const Img = styled('img')({});

export default Img;
